import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type ManifestoContractFunctions1 =
  | []
  | [ManifestoContractFunctions]
  | [ManifestoContractFunctions, ManifestoContractEvents];
export type SWEvent = {
  event: ManifestoContractEventType;
  args: any;
}[];

export interface ManifestoContractFunctions {
  approve: (
    to: string,
    tokenId: number,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<ManifestoContractEvents>}>;
  balanceOf: (owner: string, overrides?: CallOverrides) => Promise<number>;
  getApproved: (tokenId: number, overrides?: CallOverrides) => Promise<string>;
  getSignersPerPart: (part: number, overrides?: CallOverrides) => Promise<string[]>;
  hasSigned: (argument_0: number, argument_1: string, overrides?: CallOverrides) => Promise<boolean>;
  isApprovedForAll: (owner: string, operator: string, overrides?: CallOverrides) => Promise<boolean>;
  manifestoUrls: (argument_0: number, overrides?: CallOverrides) => Promise<string>;
  mint: (part: number, overrides?: CallOverrides) => Promise<{wait: () => Promise<ManifestoContractEvents>}>;
  name: (overrides?: CallOverrides) => Promise<string>;
  ownerOf: (tokenId: number, overrides?: CallOverrides) => Promise<string>;
  safeTransferFrom: (
    from: string,
    to: string,
    tokenId: number,
    _data: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<ManifestoContractEvents>}>;
  setApprovalForAll: (
    operator: string,
    approved: boolean,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<ManifestoContractEvents>}>;
  setMetadataUrl: (
    part: number,
    url: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<ManifestoContractEvents>}>;
  sign: (
    part: number,
    signer: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<ManifestoContractEvents>}>;
  supportsInterface: (interfaceId: string, overrides?: CallOverrides) => Promise<boolean>;
  symbol: (overrides?: CallOverrides) => Promise<string>;
  toClaim: (argument_0: number, argument_1: string, overrides?: CallOverrides) => Promise<boolean>;
  tokenURI: (tokenId: number, overrides?: CallOverrides) => Promise<string>;
  transferFrom: (
    from: string,
    to: string,
    tokenId: number,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<ManifestoContractEvents>}>;
}
export interface ManifestoContractEvents {
  events: SWEvent;
}

export enum ManifestoContractEventType {
  Approval = "Approval",
  ApprovalForAll = "ApprovalForAll",
  ManifestoNFTClaimed = "ManifestoNFTClaimed",
  ManifestoSigned = "ManifestoSigned",
  Transfer = "Transfer"
}
